import store from '@/core/store'
import {actionTypes} from '@/core/constants'

class BuscarParametrosListener {
    async execute() {
        return await store.dispatch(actionTypes.BUSCAR_PARAMETROS)
    }
}

export default new BuscarParametrosListener()
